import { getWeekStartsOn } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { getGoalsDeadlineEvents } from 'shared/lib/full-calendar';

export const useGoalDeadlineEvents = () => {
  const goals = useGoals();
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(
    () => getGoalsDeadlineEvents(goals, weekStartsOn),
    [goals, weekStartsOn],
  );
};
